export default function AboutSection() {
  return (
    <section id="about" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            关于我们
          </h2>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="rounded-2xl bg-background-100 border border-background-200/70 p-8 md:p-10">
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
              91黑料网成立于2020年，是国内领先的娱乐黑料与吃瓜爆料资讯聚合平台。
              我们致力于为广大吃瓜群众提供最新、最快、最全的91黑料内容，
              覆盖明星八卦、网红翻车、综艺内幕、影视黑料等多元领域。
            </p>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              平台每日更新超过50+条黑料资讯，拥有专业的编辑团队和庞大的用户投稿网络。
              我们的使命是让每一位访问91黑料网站首页的用户都能第一时间获取
              最新黑料吃瓜爆料视频，享受极致的吃瓜体验。91黑料网在线观看服务覆盖全终端，
              无论您使用电脑还是手机，都能流畅浏览所有内容。
            </p>
            <div className="mt-6 grid grid-cols-2 sm:grid-cols-4 gap-4">
              {[
                { num: '4+', label: '运营年限' },
                { num: '50+', label: '日更资讯' },
                { num: '3000+', label: '黑料资源' },
                { num: '100万+', label: '月活用户' },
              ].map((item) => (
                <div key={item.label} className="text-center p-3 rounded-lg bg-background-50">
                  <div className="font-heading text-xl md:text-2xl font-black text-primary-600">
                    {item.num}
                  </div>
                  <div className="text-xs text-foreground-400 mt-1 whitespace-nowrap">{item.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}